import { useState, useEffect } from 'react';
import { useLazyQuery, useMutation,useQuery } from '@apollo/client/react';
import CREATE_OLA3_PREFILLED from '../../../graphql/mutations/ola/createOLA3Prefilled';
import useUser from '../../../hooks/useUser';

import { Form, Row, Col, Table } from "react-bootstrap";
import {
    faUpload
} from "@fortawesome/free-solid-svg-icons";
import Papa from 'papaparse';
import CustomButton from '../../../components/CustomButton';

import COLORS from '../../../data/colors';
import CustomModal from '../../../components/CustomModal';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import toastConfiguration from '../../../data/toastConfiguration';
import GET_ERASMUS_CODES from '../../../graphql/queries/registration/getErasmusCodes';

import { useTranslation } from 'react-i18next';
import CREATE_NOMINATIONS_PREFILLED from '../../../graphql/mutations/nomination/createNominationsPrefilled';
import GET_CHECK_IIA_AVAILABILITY from '../../../graphql/queries/nomination/getCheckIIAAvailability';
import GET_ISCED_CODES from '../../../graphql/queries/IIAs/getISCEDCodes';
import GET_COUNTRIES from '../../../graphql/queries/registration/getCountries';
import GET_HEI from '../../../graphql/queries/IIAs/getHei';
import GET_HEI_NOMINATIONS from '../../../graphql/queries/nomination/getHei';

const ImportNomination = () => {
    const { user } = useUser();

    const [checkedConsent, setCheckedConsent] = useState(false);
    const [file, setFile] = useState(null);
    const [selectedFileData, setSelectedFileData] = useState(null);
    const [selectedFileError, setSelectedFileError] = useState(['Please select a CSV file']);
    const [error, setError] = useState(true);
    const [pendingUpload, setPendingUpload] = useState(false);
    const [uploadData, setUploadData] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [showModalSign, setShowModalSign] = useState(false);
    const [finishedUploading, setFinishedUploading] = useState(false);
    const [uploadResults, setUploadResults] = useState([]);
    const [uploadHasError, setUploadHasError] = useState(false);
    const [IIAexists, setIIAexists] = useState([]);
    const [isced, setIsced] = useState([]);
    const [eqf, setEqf] = useState([]);

    const handleCloseModalSign = () => setShowModalSign(false);
    const handleShowModalSign = () => setShowModalSign(true);

    const { t } = useTranslation('translation', {keyPrefix: 'learningAgreements.upload'});

    const allowedColumns = {
        "Student First Name": "field_student_first_name",
        "Student Last Name": "field_student_last_name",
        "Student Birth Date": "field_student_birth_date",
        "Student Gender": "field_student_gender",
        "Student Nationality": "field_student_nationality",
        "Student Email": "field_student_email",
        "Student ESI (Optional)": "field_student_esi",
        "Required ECTS": "field_req_ects",
        "CV Link": "field_cv_link",
        "Open Comment (Optional)": "field_open_comment",
        "External Cert Link": "field_external_cert_link",
        "Lang Level Link": "field_lang_level_link",
        "Motiv Letter Link": "field_motiv_letter_link",
        "Home IIA ID (Optional)": "field_home_iia_id",
        "Host IIA ID (Optional)": "field_host_iia_id",
        "Other Document Link": "field_other_document_link",
        "Other Requirement": "field_other_requirement",
        "Portfolio": "field_portfolio",
        "Recom Letter Link": "field_recom_letter_link",
        "Reference Contact": "field_reference_contact",
        "Tor Link": "field_tor_link",
        "Req EQF": "field_req_eqf",
        "Req ISCED": "field_req_isced",
        "Student EQF": "field_student_eqf",
        "Student ISCED": "field_student_isced",
        "Academic Year": "field_academic_year",
        "Academic Term": "field_academic_term",
        "Mobility Academic Year": "field_academic_year",
        "Mobility Academic Term": "field_academic_term",
        "Mobility Start Date": "field_start_date",
        "Mobility End Date": "field_end_date",
        "Mobility Home EC": "field_home_erasmus_code",
        "Mobility Home Name": "field_home_name",
        "Mobility Home Org Unit": "field_home_org_unit",
        "Mobility Host EC": "field_host_erasmus_code",
        "Mobility Host Name": "field_host_name",
        "Mobility Host Org Unit": "field_host_org_unit",
        "Mobility Status": "field_mobility_details_status",
        "Mobility Coop Condition ID": "field_coop_condition_id",
        "Mobility CV Required": "field_cv_required",
        "Mobility External Cert Required": "field_external_cert_required",
        "Mobility Lang Level Required": "field_lang_level_required",
        "Mobility Motivation Letter Required": "field_motivation_letter_required",
        "Mobility Other Document Required": "field_other_document_required",
        "Mobility Portfolio Required": "field_portfolio_required",
        "Mobility Recom Letter Required": "field_recom_letter_required",
        "Mobility Tor Required": "field_tor_required",
        "Mobility Other Requirement Required": "field_other_requirement_required",
        "Mobility Reference Contact Required": "field_reference_contact_required"
    };

    const academicTerms = [
        "First semester (Winter/Autumn)",
        "Second semester (Summer/Spring)",
        "First trimester",
        "Second trimester",
        "Third trimester",
        "Full academic year"
    ];

    const genders = [
        "Male",
        "Female",
        "Undefined"
    ];

    const eqfLevels = [{label: "EQF Level 5 - Associate Degree", value: "5"}, {label: "EQF Level 6 - Bachelor's Degree", value: "6"},
    {label: "EQF Level 7 - Master's Degree", value: "7"}, {label: "EQF Level 8 - Doctorate Degree", value: "8"}];

    const {
        loading: loadingEcodes,
        data: ecodes,
        error: errorEcodes,
        refetch: refetchEcodes
    } = useQuery(GET_ERASMUS_CODES, {
        variables: { countryCodes: [] }
    });

    const {
            loading: loadingISCEDCodes,
            error: errorISCEDCodes,
            data: dataISCEDCodes,
          } = useQuery(GET_ISCED_CODES);

    const {
            loading: loadingCountries,
            error: errorCountries,
            data: dataCountries,
          } = useQuery(GET_COUNTRIES);

    const {
            loading: loadingHomeHei,
            error: errorHomeHei,
            data: dataHomeHei,
          } = useQuery(GET_HEI, {
        variables: { heiID: user?.heiID }
    });

    const {
            loading: loadingHostHei,
            error: errorHostHei,
            data: dataHostHei,
            refetch: refetchHostHei
          } = useQuery(GET_HEI_NOMINATIONS, {
        variables: { erasmusCode: "" }
    });

    const {
        loading: loadingIIA,
        data: iiAData,
        error: errorIIA,
        refetch: refetchIIA
    } = useQuery(GET_CHECK_IIA_AVAILABILITY, {
        variables: { homeErasmusCode: '', hostErasmusCode: '' }
    });

    const [
        createOLA3prefilled,
        {
            error: errorCreateOLA3prefilled
        },
    ] = useMutation(CREATE_NOMINATIONS_PREFILLED);


    useEffect(() => {
        if (uploadData) {
            uploadHandler();
        }
    }, [uploadData]);

    useEffect(() => {
        if (file?.length > 0) {
            fileHandler();
        }
    }, [file]);

    useEffect(() => {
        if (selectedFileData?.length > 0) {
            checkIIAAvailability();
        }
    }, [selectedFileData]);

    const checkConsent = () => {
        setCheckedConsent(!checkedConsent);
    }

    const checkIIAAvailability = async () => {
        const iiAResults = [];
        
        // Loop through all CSV rows
        for (let i = 0; i < selectedFileData.length; i++) {
            const row = selectedFileData[i];
            console.log(`Checking IIA availability for row ${i + 1}:`, {
                homeErasmusCode: row["Mobility Home EC"],
                hostErasmusCode: row["Mobility Host EC"]
            });
            
            const availability = await refetchIIA({
                homeErasmusCode: row["Mobility Home EC"],
                hostErasmusCode: row["Mobility Host EC"]
            });
            
            const exists = availability?.data?.checkIIAAvailability?.exists || false;
            iiAResults.push(exists);
            
            console.log(`Row ${i + 1} IIA exists:`, exists);
        }
        
        // Update state once with all results
        setIIAexists(iiAResults);
    }

    const fileHandler = () => {
        Papa.parse(file[0], {
            skipEmptyLines: true,
            header: true,
            complete: results => {
                csvHandler(results)
            }
        });

    }

    const isTemplateValid = (data) => {
        let csvHeader = data;

        if (csvHeader[0] !== "Student Name" || csvHeader[1] !== "Student Email" || csvHeader[2] !== "Student ESI" || csvHeader[3] !== "Required ECTS" ||
            csvHeader[4] !== "CV Link" || csvHeader[5] !== "Student EQF" || csvHeader[6] !== "Student ISCED" || csvHeader[7] !== "Academic Year" ||
            csvHeader[8] !== "Academic Term") {

            return false;
        }

        for (let i = 9; i < csvHeader.length; i += 15) {
            if (csvHeader[i] !== "Mobility Academic Year" || csvHeader[i + 1] !== "Mobility Academic Term" || csvHeader[i + 2] !== "Mobility Start Date" || csvHeader[i + 3] !== "Mobility End Date" || csvHeader[i + 4] !== "Mobility Home EC" || csvHeader[i + 5] !== "Mobility Home Name" || csvHeader[i + 6] !== "Mobility Host EC" ||
                csvHeader[i + 7] !== "Mobility Host Name") {
                return false;
            }
        }

        return true;
    }

    const csvHandler = async (data) => {
        const header = Object.keys(data.data[0])
        if (!validateColumnNames(header) && !validateData(data.data)) {
            const newData = [...data.data]
            setSelectedFileData(newData);
            setSelectedFileError([]);
            setError(false);
            const availability = await refetchIIA(newData);
        } else {
            setError(true);
        }
    }

    const validateEmail = (email) => {
        email = email.replace(/\s+/g, '');
        const regEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regEx.test(String(email).toLowerCase());
    }

    const validateDate = (date) => {
        const dateString = String(date)
        const regEx = /^\d{4}-\d{2}-\d{2}$/;
        if (!dateString.match(regEx)) {
            return false;
        } // Invalid format
        const parts = dateString.split("-");
        const d = new Date(parts[0], parts[1] - 1, parts[2]);
        const dNum = d.getTime();
        if (!dNum && dNum !== 0) return false; // NaN value, Invalid date
        return true;
    }


    const validateColumnNames = (columns) => {
        let hasError = false;
        columns.forEach(element => {
            hasError = !Object.keys(allowedColumns).includes(element) ? true : false;
        });
        if (hasError) {
            setError(true);
            setSelectedFileError(["Error: Invalid column names. "]);
        }
        return hasError;
    }

    const validateData = (data) => {
        let hasError = false;
        let errors = [];
        let iscedTemp = [];
        let eqfTemp = [];
        for (var key in data) {

            let partnerHei = ecodes?.heis?.find(ec => data[key]["Mobility Host EC"] === ec?.erasmusCode);
            let academic_term = academicTerms.find(value => data[key]["Mobility Academic Term"] === value);
            let gender = genders.find(value => data[key]["Student Gender"] === value);
            let isced = dataISCEDCodes?.iscedCodes?.find(value => data[key]["Student ISCED"] === value.code);
            let eqf = eqfLevels.find(value => data[key]["Student EQF"] === value.value);
            let country = dataCountries?.countries?.find(value => data[key]["Student Nationality"] === value.CountryISO);

            if(partnerHei===undefined){
                hasError = true;
                setError(true);
                errors.push(t('validateData.invalidCode.part1')+ data[key]["Mobility Host EC"] +t('validateData.invalidCode.part2')+ (parseInt(key) + 2) + ".");
            }

            if(academic_term===undefined){
                hasError = true;
                setError(true);
                errors.push(data[key]["Mobility Academic Term"] +": Invalid Academic Term at "+ (parseInt(key) + 1) + " row.");
            }

            if(gender===undefined){
                hasError = true;
                setError(true);
                errors.push(data[key]["Student Gender"] +": Invalid Gender at "+ (parseInt(key) + 1) + " row.");
            }

            if(country===undefined){
                hasError = true;
                setError(true);
                errors.push(data[key]["Student Nationality"] +": Invalid Nationality at "+ (parseInt(key) + 1) + " row.");
            }

            if(isced===undefined){
                hasError = true;
                setError(true);
                errors.push(data[key]["Student ISCED"] +": Invalid ISCED at "+ (parseInt(key) + 1) + " row.");
            }
            else {
                iscedTemp.push(`${isced.code} - ${isced.name}`);
            }
            if(eqf===undefined){
                hasError = true;
                setError(true);
                errors.push(data[key]["Student EQF"] +": Invalid EQF at "+ (parseInt(key) + 1) + " row.");
            }
            else {
                eqfTemp.push(eqf.label);
            }
            if (data[key]["Student Email"] === "" || data[key]["Student Gender"] === ""
                || data[key]["Student Birth Date"] === "" || data[key]["Student Nationality"] === ""
                || data[key]["Student ISCED"] === "" || data[key]["Student EQF"] === ""
                || data[key]["Student First Name"] === "" || data[key]["Student Last Name"] === ""
                || data[key]["Academic Year"] === "" || data[key]["Mobility Host EC"] === ""
                || data[key]["Mobility Academic Term"] === ""
            ) {
                hasError = true;
                setError(true);
                errors.push("Missing required fields at row " + (parseInt(key) + 1));
            }
            if (data[key]["Student Email"] != "") {
                if (!(validateEmail(data[key]["Student Email"]))) {
                    hasError = true;
                    setError(true);
                    errors.push(t('validateData.emailError.part1') + (parseInt(key) + 2) + t('validateData.emailError.part2'));
                }
                if (!(validateDate(data[key]["Student Birth Date"]))) {
                    hasError = true;
                    setError(true);
                    errors.push(t('validateData.dataError.part1')+ (parseInt(key) + 2) + ": Make your dates are in yyyy-mm-dd format.");
                }
            } else {
                //it is an emtpy line, so remove it.
                data.splice(key, 1);
            }
        }
        if (data.length > 25) {
            hasError = true;
            setError(true);
            errors.push("File error: You can only upload 25 Nominations at once.");
        }
        setSelectedFileError(errors);
        setIsced(iscedTemp);
        setEqf(eqfTemp);
        return hasError;
    }


    const convertData = async (data) => {
        const header = Object.keys(data[0]);
        let hostName = [];
        for (var key in data) {
            hostName.push(await refetchHostHei({erasmusCode: data[key]["Mobility Host EC"]}));
        }
        return data.map((item, index) => {
            const newPrefilledLA = {};
            let bound = 9;
            for (let i = 0; i < header.length; i++) {
                console.log(item[header[i]], allowedColumns[header[i]]);
                if (allowedColumns[header[i]] === "field_open_comment") {
                    bound = 10;
                }
                if (allowedColumns[header[i]] === "field_student_esi" && bound === 10) {
                    bound = 11;
                } else if (allowedColumns[header[i]] === "field_student_esi") {
                    bound = 10;
                }
            }
            for (let i = 0; i < bound; i++) {
                // newPrefilledLA[allowedColumns[header[i]]] = item[header[i]]
                // if (allowedColumns[header[i]] === "field_req_ects") {
                //     newPrefilledLA[allowedColumns[header[i]]] = parseInt(item[header[i]]);
                // }
                // else {
                    newPrefilledLA[allowedColumns[header[i]]] = item[header[i]];
                // }
            }
            //header.forEach(column => newPrefilledLA[allowedColumns[column]] = item[column]);

            newPrefilledLA.mobility_details = [];
            let mobilityDetail = {};
            for (let i = bound; i < header.length; i++) {
                if (allowedColumns[header[i]] === "field_cv_required" || allowedColumns[header[i]] === "field_external_cert_required" ||
                    allowedColumns[header[i]] === "field_lang_level_required" || allowedColumns[header[i]] === "field_motivation_letter_required" ||
                    allowedColumns[header[i]] === "field_other_document_required" || allowedColumns[header[i]] === "field_portfolio_required" ||
                    allowedColumns[header[i]] === "field_recom_letter_required" || allowedColumns[header[i]] === "field_tor_required" ||
                    allowedColumns[header[i]] === "field_other_requirement_required" || allowedColumns[header[i]] === "field_reference_contact_required"
                ) {
                    mobilityDetail[allowedColumns[header[i]]] = item[header[i]] === "true" || item[header[i]] ? true : false;
                }
                // else {
                // if (allowedColumns[header[i]] === "field_academic_year") {
                //     mobilityDetail = {};
                //     mobilityDetail[allowedColumns[header[i]]] = item[header[i]];
                // } 
                // else if (allowedColumns[header[i]] === "field_reference_contact_required") {
                //     mobilityDetail[allowedColumns[header[i]]] = item[header[i]];
                    
                //     console.log(newPrefilledLA);
                //     mobilityDetail = {};
                // }
                 else {
                    mobilityDetail[allowedColumns[header[i]]] = item[header[i]];
                }
                    
                // }
                
                // if(i === 16) {
                    
                // }
            }
            newPrefilledLA.mobility_details.push(mobilityDetail);
            //Add Erasmus Code of current account as sending institution
            newPrefilledLA.mobility_details[0]["field_home_erasmus_code"] = user?.erasmusCode;
            newPrefilledLA.mobility_details[0]["field_home_name"] = dataHomeHei?.hei?.name;
            newPrefilledLA.mobility_details[0]["field_host_name"] = hostName[index]?.data?.hei?.name;
            newPrefilledLA.field_student_isced = isced[index];
            newPrefilledLA.field_student_eqf = eqf[index];
            return newPrefilledLA;
        })
    }

    const uploadHandler = async () => {
        const toastId = toast.loading("Uploading Nominations...", toastConfiguration);
        let tempUploadData = [...uploadResults];
        try {
            const convertedData = await convertData(selectedFileData);
            console.log(convertedData);
            const variables = {
                data: convertedData,
            }
            const dataCreateOLA3prefilled = await createOLA3prefilled({ variables });
            tempUploadData = tempUploadData.concat(dataCreateOLA3prefilled?.data?.createNominationsPrefilled?.map((item) => <p className={`${item.includes("was not created") ? 'text-danger' : ''}`}>{item}</p>))
            const checkForUploadErrors = dataCreateOLA3prefilled?.data?.createNominationsPrefilled?.find((item) => item.includes("was not created"));
            setUploadHasError(checkForUploadErrors ? true : false)
            toast.update(toastId, {
                ...toastConfiguration,
                render: "Successfully uploaded nominations",
                type: "success",
                isLoading: false,
            });
            setFinishedUploading(true);
            setFile(null);
            setShowPreview(false);
            setCheckedConsent(false);
            setError(true);
            setSelectedFileData(null);
            setSelectedFileError(['Please select a CSV file']);
        } catch (error) {
            if (error) {
                tempUploadData = tempUploadData.concat(error?.map((item) => <p>{item?.message}</p>));
                toast.update(toastId, {
                    ...toastConfiguration,
                    render: "There were some errors while uploading Nominations.",
                    type: "error",
                    isLoading: false,
                });
            }
        }
        setUploadResults(tempUploadData);
    }

    let rowNum = 0;


    const renderRow = (rowData, header) => {

        if (header) {
            const columns = rowData.map((column, index) => {
                return (
                    <th className='h6-style' key={index}>
                        {column}
                    </th>
                )
            })
            return (
                <tr className='main-background rounded custom-row ' style={{
                    border: "10px solid #F2F3F6",
                    borderBottom: "20px solid #F2F3F6"
                }} key={rowNum++ + "row"}>{columns}
                </tr>
            )
        }

        const columns = rowData.map((column, index) => {
            return (
                <td key={index}>
                    {header ? <h4>{column}</h4> : <p key={index}>{column}</p>}
                </td>
            )
        })
        return (
            <><tr className='rounded custom-row' style={{border: "0px solid #F2F3F6"}} key={rowNum++ + "row"}>{columns}
            </tr>
            {IIAexists.map((exists, index) => (
                        (!exists && (index + 1) === rowNum) && (<tr className='rounded custom-row' style={{
                border: "0px solid #F2F3F6", 
                width: "100%", marginBottom: 0
            }}>
                <td colSpan="100%" style={{ width: "100%" }}>
                    
                            <div key={index}>
                                <span style={{color:"orange"}}>! </span>
                                {`No corresponding IIA with the Receiving Institution found for nominating this student.`}
                            </div>
                        
                </td>
            </tr>)
                    ))}</>
        )
    }

    const renderTable = (data) => {
        let header = Object.keys(data[0])
        const body = data.map(item => {
            const rowData = header.map(columnName => item[columnName]);
            return renderRow(rowData)
        })
        header = renderRow(header, true)
        return (
            <div>
                <Table>
                    <thead>
                        {header}
                    </thead>
                    <tbody>
                        {body}
                    </tbody>
                </Table>
            </div>
        )
    }

    const returnToUploadPageAndReset = () => {
        setFile(null);
        setFinishedUploading(false);
        setUploadData(false);
        setShowPreview(false);
        setCheckedConsent(false);
        setPendingUpload(false);
        setError(true);
        setSelectedFileData(null);
        setSelectedFileError(['Please select a CSV file']);
        setUploadHasError(false);
        setUploadResults([]);
    }

    const cancelUpload = () => {
        setFile(null);
        setShowPreview(false);
        setCheckedConsent(false);
        setPendingUpload(false);
        setError(true);
        setSelectedFileData(null);
        setSelectedFileError(['Please select a CSV file']);
        setUploadHasError(false);
        setUploadResults([]);
    }


    const uploadAcceptedAfterPreview = () => {
        setUploadData(true);
        handleCloseModalSign();
        setShowPreview(false);
        setPendingUpload(true);
    }


    if (showPreview) {
        return (
            <main className="mx-5 pt-4 pt-xxl-5">
                <h3 className='h3-upload'>Uploading Nominations</h3>
                {renderTable(selectedFileData)}
                {/* <div>
                    {IIAexists.every(exists => exists === false) && (
                        <p className="text-warning">
                            No corresponding IIA with the Receiving Institution found for nominating this student.
                        </p>
                    )}
                </div> */}
                <Row>
                    <Col style={{ marginTop: 36, display: "flex", justifyContent: "flex-end" }}>
                        <CustomButton buttonType={"secondary"} styles={{ marginRight: "10px" }} small={true} text={t('cancel')} handleClick={cancelUpload} />
                        <CustomButton buttonType={"primary"} small={true} text={t('upload')} hasIcon={true} iconColor={COLORS.white} icon={faUpload} handleClick={handleShowModalSign} />
                    </Col>
                </Row>
                <CustomModal show={showModalSign} handleClose={handleCloseModalSign}
                    fullscreen={false}
                    button={<CustomButton buttonType={"primary"} text={t('upload')} hasIcon={true} iconColor={COLORS.white} icon={faUpload} handleClick={uploadAcceptedAfterPreview} />}
                    title={<div style={{ paddingBottom: "20px" }}>{t('title.part1')}<span style={{ color: "#3D619C" }}>{t('title.part2')}</span> Nominations</div>} 
                    body={"By clicking “Upload” the nominated students’ data will be communicated to the Receiving HEI"}/>
            </main>
        )
    }

    if (pendingUpload) {
        return (
            <div className="mx-5 pt-4 pt-xxl-5">
                <h3 className='h3-upload'>Uploading Nominations</h3>
                <p className='upload-subtitle'>{t('dontClosePage')}</p>
                {(uploadResults && uploadResults?.length > 0) && <div className='p-2 upload-results'>
                    {uploadResults}
                </div>}
                {(errorCreateOLA3prefilled || uploadHasError) && (
                    <div className="text-danger mx-auto mt-4">
                        {/* <p style={{ "marginTop": "10px", fontFamily: 'Raleway' }}>{t('commonErrors.part1')}
                            <a rel="noopener noreferrer"
                                target="_blank"
                                href="https://esci-sd.atlassian.net/wiki/spaces/DASH/pages/11862139/Common+errors+when+uploading+a+CSV+OLA">
                                {t('commonErrors.part2')}
                            </a>
                        </p> */}
                    </div>
                )}
                {finishedUploading &&
                    <Row>
                        <Col style={{ marginTop: 36, display: "flex", justifyContent: "flex-end" }}>
                            <CustomButton buttonType={"primary"} small={true} text={t('returnToUploadPage')} handleClick={returnToUploadPageAndReset} />
                        </Col>
                    </Row>
                }
                <ToastContainer
                    position="bottom-left"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </div>
        )
    }

    return (
        <div className="d-flex justify-content-between mx-5 pt-4 pt-xxl-5">
            <Form noValidate validated={true} id={"upload-ola-form"}>
                <h3 className='h3-upload'>
                    Upload CSV file to Nominate Students
                </h3>
                <p className='body-upload'>
                    {/* {t('bodyUpload.part1')} */}
                    <br />
                    The student nomination functionality now supports a CSV upload. By uploading a CSV file, you can review the full list of students, verify that all information is correct, and then submit the data to nominate the students via EWP. The format of the CSV file can be verified through the use of a template spreadsheet made available on the EWP CC 
                    <a rel="noopener noreferrer"
                        target="_blank"
                        href="https://esci-sd.atlassian.net/wiki/spaces/DASH/pages/1482948610/Nominations+CSV+Upload">
                         {' '} {t('bodyUpload.part3')}
                    </a>.
                </p>
                <Form.Group controlId="formFile" className="mb-3">
                    <Form.Control type="file" accept='.csv' onChange={(e) => setFile(e.target.files)} required isInvalid={error === true} />
                    <Form.Control.Feedback type="invalid">
                    {(selectedFileError && selectedFileError?.length > 0) && <div className='text-danger'>
                    {selectedFileError?.map(i => <>{i}<br/></>)}
                </div>}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group controlId="formAuthorizations">
                    <Form.Check type="checkbox" id="check-authorizations">
                        <Form.Check.Input type="checkbox" required onChange={checkConsent} />
                        <Form.Check.Label>
                            {t('checkBox')}
                        </Form.Check.Label>
                        <Form.Control.Feedback type="invalid">
                            {t('consent')}
                        </Form.Control.Feedback>
                    </Form.Check>
                </Form.Group>
                <Row>
                    <Col style={{ marginTop: 36, display: "flex", justifyContent: "flex-end" }}>
                        <CustomButton disabled={!(checkedConsent && file?.length > 0 && !error)} buttonType={"primary"} small={true} text={t('upload')} hasIcon={true} iconColor={COLORS.white} icon={faUpload} handleClick={() => {
                            setShowPreview(true);
                        }} />
                    </Col>
                </Row>
            </Form>
        </div>)
};

export default ImportNomination;